import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { notificacoesService } from "@/core/services/notificacoesService";
import { useAuth } from "@/core/hooks/useAuth";

const notifKey = (pessoaId: string) => ["minhas-notificacoes", pessoaId];

/**
 * Notificações da pessoa logada (ARQ-04). Mesmo padrão de useMeusConvites:
 * polling de 60s, já que ainda não há realtime aqui.
 */
export function useMinhasNotificacoes() {
  const { pessoa } = useAuth();
  return useQuery({
    queryKey: notifKey(pessoa?.id ?? ""),
    queryFn: () => notificacoesService.listar(pessoa!.id),
    enabled: !!pessoa,
    refetchInterval: 60_000,
  });
}

export function useMarcarNotificacaoLida() {
  const queryClient = useQueryClient();
  const { pessoa } = useAuth();
  return useMutation({
    mutationFn: (id: string) => notificacoesService.marcarComoLida(id),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: notifKey(pessoa?.id ?? "") }),
  });
}

export function useMarcarTodasNotificacoesLidas() {
  const queryClient = useQueryClient();
  const { pessoa } = useAuth();
  return useMutation({
    mutationFn: () => notificacoesService.marcarTodasComoLidas(pessoa!.id),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: notifKey(pessoa?.id ?? "") }),
  });
}

/** "Excluir todas" do sino (02/11/2026): apaga todas as notificações da pessoa. */
export function useApagarTodasNotificacoes() {
  const queryClient = useQueryClient();
  const { pessoa } = useAuth();
  return useMutation({
    mutationFn: () => notificacoesService.apagarTodas(pessoa!.id),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: notifKey(pessoa?.id ?? "") }),
  });
}

/** A32 (reteste 22-23/07/2026): apaga uma notificação. */
export function useApagarNotificacao() {
  const queryClient = useQueryClient();
  const { pessoa } = useAuth();
  return useMutation({
    mutationFn: (id: string) => notificacoesService.apagar(id),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: notifKey(pessoa?.id ?? "") }),
  });
}
